import React, { Component } from 'react';

import FormInput from './FormInput.js'
import { getTranslation } from '../Utilities/GetTranslation.js'
import { isEmpty } from '../Utilities/JsonFunctions.js';

class FormCreatePassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            password1: "",
            password2: "",
            password1validation: getTranslation("basicform.erroremptyvalue"),
            password2validation: getTranslation("basicform.erroremptyvalue"),
            valid: false,
            showLegend: this.props.showLegend == null ? true : this.props.showLegend
        }
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {

        var password1 = this.state.password1;
        var password2 = this.state.password2;
        var password1validation = "";
        var password2validation = "";
        var valid = true;

        if (e.target.id === "password1") {
            password1 = e.target.value;
        } else {
            password2 = e.target.value;
        }

        if (!/^[\s\S]{8,}$/.test(password1)) {
            // password rule error
            password1validation = getTranslation("sns.webparts.register.password.error");
            valid = false;
        }

        if (password1 !== password2) {
            // password confirm error
            password2validation = getTranslation("sns.webparts.register.passwordconfirm.error");
            valid = false;
        }

        if (isEmpty(password1)) {
            password1validation = getTranslation("basicform.erroremptyvalue");
        }

        if (isEmpty(password2)) {
            password2validation = getTranslation("basicform.erroremptyvalue");
        }

        this.setState({
            password1: password1,
            password2: password2,
            password1validation: password1validation,
            password2validation: password2validation,
            valid: valid
        });

        this.props.onChange(e, password1, valid);
    }

    render() {
        return (
            <div>
                {
                    this.state.showLegend ?
                        <h4 className="legend-title">{getTranslation("sns.webparts.register.password")}</h4> : 
                        ""
                }
                <div style={{ height: "0px", overflow: "hidden", position: "absolute" }}>
                    <input type="text" name="username" />
                </div>
                <FormInput id="password1"
                    text={getTranslation("sns.webparts.register.password")}
                    explanation={getTranslation("sns.webparts.register.password.info")}
                    required={true}
                    type="password"
                    showValidation={this.props.showValidation}
                    validationText={this.state.password1validation} 
                    autocomplete="new-password"                    
                    value={this.state.password1}
                    onChange={this.onChange} />
                <FormInput id="password2"
                    text={getTranslation("sns.webparts.register.passwordconfirm")}
                    required={true}
                    type="password"
                    showValidation={this.props.showValidation}
                    validationText={this.state.password2validation}
                    autocomplete="new-password"
                    value={this.state.password2} 
                    onChange={this.onChange} />
            </div>
        );
    }
}

export default FormCreatePassword;


// WEBPACK FOOTER //
// ./src/Fields/FormCreatePassword.js